import { render, staticRenderFns } from "./ModalTagAdd.vue?vue&type=template&id=70664dfa&scoped=true"
import script from "./ModalTagAdd.vue?vue&type=script&lang=js"
export * from "./ModalTagAdd.vue?vue&type=script&lang=js"
import style0 from "./ModalTagAdd.vue?vue&type=style&index=0&id=70664dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70664dfa",
  null
  
)

export default component.exports